/* GLOBAL HIGHTLIGHT **********************************************************/

/**
* Select a item by its domain and id
**/
export const SET_ACTIVE = 'highlight/SET_ACTIVE'
export const setActive = (domain, uid) => {
  return (dispatch) => {
    dispatch({ type: SET_ACTIVE, payload:{domain, uid} })
    //dispatch(findRelated())
  }
}

export const TOGGLE_ACTIVE = 'highlight/TOGGLE_ACTIVE'
export const toggleActive = (domain, uid) => {
  return (dispatch) => {
    dispatch({ type: TOGGLE_ACTIVE, payload:{domain, uid} })
    //  dispatch(findRelated())
  }
}

export const RESET_ACTIVE = 'highlight/RESET_ACTIVE'
export const resetActive = () => {
  return (dispatch) => {
    dispatch({ type: RESET_ACTIVE })
    //dispatch(findRelated())
  }
}

/**
* Select a item by its domain and id
**/
export const SELECT = 'highlight/SELECT'
export const select = (domain, uid) => {
  return { type: SELECT, payload: {domain, uid}}
}

/**
* Select a item by its domain and id
**/
export const SET_SELECT = 'highlight/SET_SELECT'
export const setSelect = (domain, uid) => {
  return { type: SET_SELECT, payload: {domain, uid}}
}

/**
* Deselect a item by its domain and id
**/
export const TOGGLE_SELECT = 'highlight/TOGGLE_SELECT'
export const toggleSelect = (domain, uid) => {
  return { type: TOGGLE_SELECT, payload: {domain, uid}}
}

/**
* Deselect a item by its domain and id
**/
export const DESELECT = 'highlight/DESELECT'
export const deselect = (domain, uid) => {
  return { type: DESELECT, payload: {domain, uid}}
}

/**
* Deselect a item by its domain and id
**/
export const DESELECT_ALL = 'highlight/DESELECT_ALL'
export const deselectAll = () => {
  return { type: DESELECT_ALL }
}

/**
* Hard reset
**/
export const RESET = 'highlight/RESET'
export const reset = () => {
    return { type: RESET }
}

/**
* Set items that are some kind of parent of the currently selected iten
**/
export const SET_ASCENDANTS = 'highlight/SET_ASCENDANTS'
export const setAscendants = (ascendants) => {
    return { type: SET_ASCENDANTS, ascendants }
}

/**
* Set items that are some kind of child of the currently selected iten
**/
export const SET_DESCENDANTS = 'highlight/SET_DESCENDANTS'
export const setDescendants = (descendants) => {
    return { type: SET_DESCENDANTS, descendants }
}

/**
* Set items that are somehow related to the currently selected item
**/
export const SET_RELATED = 'highlight/SET_RELATED'
export const setRelated = (ascendants, descendants) => {
    return { type: SET_RELATED, ascendants, descendants }
}

/**
* Reset all
*/
export const RESET_RELATED = 'highlight/RESET_RELATED'
export const resetRelated = () => {
    return (dispatch, getState) => {
        dispatch({ type: RESET_RELATED })
    }
}

/**
* Procedure to find all related items
* Heavy data traversing (expensive)
*/
export const FIND_RELATED = 'highlight/FIND_RELATED'
export const findRelated = ()  => {
  return (dispatch, getState) => {
    const state = getState()
    const uid = state.highlight.active.uid
    const domain = state.highlight.active.domain
    const playlists = state.playlist.list.items
    const mediaplayers = state.mediaPlayer.list.items
    const surfaces = state.mediaPlayer.list.surfaces
    const assets = state.asset.items
    let ascendants = { playlist:{}, asset:{}, mediaplayer:{}, surface: {} }
    let descendants = { playlist:{}, asset:{}, mediaplayer:{}, surface: {} }
    // descendants
    switch (domain) {
      case "asset":
        _.each(playlists, (playlist, playlistId) => {
          _.each(playlist.mediaObjects, (mediaObject, index) => {
            if(mediaObject.assetId === uid) {
              ascendants.playlist[playlistId] = true
              _.each(surfaces, (mediaplayerSurfaces, mediaPlayerId) => {
                _.each(mediaplayerSurfaces, (surface, surfaceId) => {
                  if (surface.playlistId === playlistId) {
                      ascendants.mediaplayer[mediaPlayerId] = true
                      ascendants.surface[surfaceId] = true
                  }
                })
              })
            }
          })
        })
      break
      case "playlist":
        _.each(surfaces, (mediaplayerSurfaces, mediaPlayerId) => {
          _.each(mediaplayerSurfaces, (surface, surfaceId) => {
            if (surface.playlistId === uid) {
              ascendants.mediaplayer[mediaPlayerId] = true
              ascendants.surface[surfaceId] = true
            }
          })
        })
      break
      case "mediaplayer":
        _.each(surfaces[uid], (surface, surfaceId) => {
          descendants.surface[surfaceId] = true
        })
      break
    }
    // ascendants
    switch (domain) {
      case "surface":
        _.each(surfaces, (mediaplayerSurfaces, mediaPlayerId) => {
          _.each(mediaplayerSurfaces, (surface, surfaceId) => {
            if (surfaceId === uid) {
              ascendants.mediaplayer[mediaPlayerId] = true
              if (playlists[surface.playlistId]) {
                descendants.playlist[surface.playlistId] = true
                _.each(
                  playlists[surface.playlistId].mediaObjects,
                  (mediaObject) => {
                    descendants.asset[mediaObject.assetId] = true
                  }
                )
              }
            }
          })
        })
        _.each(surfaces[uid], (surface, surfaceId) => {
          descendants.playlist[surface.playlistId] = true
          if(playlists[surface.playlistId]){
            _.each(
              playlists[surface.playlistId].mediaObjects,
              (mediaObject) => {
                descendants.asset[mediaObject.assetId] = true
              }
            )
          }
        })

      break
      case "mediaplayer":
        _.each(surfaces[uid], (surface, surfaceId) => {
          descendants.playlist[surface.playlistId] = true
          if(playlists[surface.playlistId]){
            _.each(
              playlists[surface.playlistId].mediaObjects,
              (mediaObject) => {
                descendants.asset[mediaObject.assetId] = true
              }
            )
          }
        })
      break
      case "playlist":
        if(playlists[uid]){
          _.each(playlists[uid].mediaObjects, (mediaObject) => {
              descendants.asset[mediaObject.assetId] = true
          })
        }
      break
    }
    dispatch(setRelated(ascendants, descendants))
  }
}



// WEBPACK FOOTER //
// ./src/app/react-redux/actions/highlight.js